import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6abbc837")

_pushScopeId("data-v-6abbc837")
const _hoisted_1 = { class: "fridgedetailsmyassistlist" }
const _hoisted_2 = {
  key: 0,
  class: "fridgedetailsmyassistlist-valid"
}
const _hoisted_3 = {
  key: 0,
  class: "ridgedetailsmyassistlist-valid-list"
}
const _hoisted_4 = {
  key: 1,
  class: "fridgedetailsmyassistlist-valid-nolist"
}
const _hoisted_5 = { class: "fridgedetailsmyassistlist-valid-nolist-message" }
const _hoisted_6 = { class: "fridgedetailsmyassistlist-valid-nolist-message-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsMyAssistListItem = _resolveComponent("FridgeDetailsMyAssistListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isValidList)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.isValidMyAssist)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                  return (_openBlock(), _createBlock(_component_FridgeDetailsMyAssistListItem, {
                    key: item.index,
                    index: item.index,
                    name: item.name,
                    mode: item.mode,
                    settingTime: item.timeString,
                    isEditMode: _ctx.isEditMode,
                    onClickItem: _ctx.clickItem,
                    onClickDeleteItem: _ctx.clickDeleteItem
                  }, null, 8, ["index", "name", "mode", "settingTime", "isEditMode", "onClickItem", "onClickDeleteItem"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.noListText), 1)
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
})